var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AdminHome"},[_c('AdminHeader'),_c('router-view',{staticClass:"HomeBody"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }